export const AktivGroteskMedium = {
  src: `url(https://cdn.ownup.com/component-library/latest/AktivGrotesk_W_Md.woff),
        url(https://cdn.ownup.com/component-library/latest/AktivGrotesk_W_Md.woff2)`
};
